import { render, staticRenderFns } from "./DemoConfigShow.vue?vue&type=template&id=35f739e1"
import script from "./DemoConfigShow.vue?vue&type=script&lang=ts"
export * from "./DemoConfigShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports